import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.billing.all(), data);
  },
  updateStatus(data = {}) {
    return BackendAPI('put', ApiRoutes.billing.updateStatus(), data);
  },
  fetchExcel(data = {}) {
    return BackendAPI('get', ApiRoutes.billing.fetchExcel(), data);
  },
  callExcelGeneration(data = {}) {
    return BackendAPI('post', ApiRoutes.billing.callExcelGeneration(), data);
  },
};
